import { GRID2D_BUTTON__hide_sidebars } from '@/pages/_base/grid2d/bars/buttons/GRID2D_BUTTON__hide_sidebars';
import { G_BUTTON__graph_autolayout } from './_buttons/G_BUTTON__graph_autolayout';
import { G_BUTTON__graph_clear } from './_buttons/G_BUTTON__graph_clear';
import { G_BUTTON__graph_fit_view } from './_buttons/G_BUTTON__graph_fit_view';

export function G_BAR__generation_graph_actions() {
  return (
    <>
      <div className="flex  items-center justify-between  gap-1 bg-bar rounded-lg border border-component-border">
        <G_BUTTON__graph_fit_view />
        <G_BUTTON__graph_autolayout />
        <G_BUTTON__graph_clear />
        <GRID2D_BUTTON__hide_sidebars />
      </div>
    </>
  );
}
